module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp3_9005.7fe26cd9.png";